import React from 'react'
import EaseContactInfo from "./EaseContactInfo"

class MessageComponent extends React.Component {
    constructor(props){
        super(props);
        this.messageContent = props.messageContent;
        this.messages = props.messages;
    }

    render(){
        return (

          <div>
              <div>{this.messageContent}</div>
              <p>{this.messages['ease.contact.question']}</p>
              <EaseContactInfo messages={this.messages} />
          </div>
        );
    }
}

export default MessageComponent;